// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dugtrio_alola: PokeData = {
  "id": 10106,
  "name": "dugtrio-alola",
  "height": 7,
  "weight": 666,
  "base_experience": 149,
  "types": [
    PokeType.GROUND,
    PokeType.STEEL
  ],
  "api_moves": [
    "scratch",
    "sand-attack",
    "growl",
    "earthquake",
    "fissure",
    "dig",
    "agility",
    "screech",
    "fury-swipes",
    "tri-attack",
    "slash",
    "mud-slap",
    "sandstorm",
    "magnitude",
    "metal-claw",
    "astonish",
    "sand-tomb",
    "sucker-punch",
    "night-slash",
    "earth-power",
    "mud-bomb",
    "iron-head",
    "bulldoze",
    "rototiller"
  ],
  "moves": [
    "scratch",
    "growl",
    "earthquake",
    "fissure",
    "tri-attack",
    "mud-slap",
    "sandstorm",
    "magnitude",
    "metal-claw",
    "night-slash",
    "earth-power",
    "mud-bomb",
    "rototiller"
  ],
  "evolution_chain": {
    "id": 21,
    "item": null,
    "species": [
      {
        "name": "diglett",
        "order": 55,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dugtrio",
        "order": 56,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": 50,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 26,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 77,
    "speed": 169,
    "ability_power": 154
  },
  "stat_changes": [],
  "catch_rate": 50,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "alola"
} as const;
